import template from './assets.template.html';

export default {
  template,
  bindings: {
    formName: '<',
    assets: '<',
    contacts: '<',
    workflow: '<',
    countries: '<',
    lenders: '<',
    ticketOwner: '<',
    diversificationOpportunities: '<',
    addresses: '<',
    documents: '<',
    outboundReferrers: '<',
    validationErrors: '<',
    ticket: '<',
    idAli: '<',
    isContactAsset: '<',
    isTicketSettled: '<',
    onFinished: '&',
    onDiversificationFinished: '&',
    onDiversificationIntegrationFinished: '&',
    onValidated: '&'
  },
  controller: class controller {
    constructor(
      $rootScope,
      $timeout,
      eventService,
      helperService,
      assetsService,
      OpportunityType,
      OpportunityContextualType,
      diversificationOpportunityService,
      financesService
    ) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = $rootScope.CurrentOrganization;
      ctrl.currentCurrency = $rootScope.CurrentCurrency();
      ctrl.organizationCountry = '';
      ctrl.availableAssetTypes = [];
      ctrl.mortgageLoanLenders = [];
      ctrl.assetsEstimate = [];
      ctrl.isProcessing = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry().name;
        ctrl.availableAssetTypes = assetsService.getAvailableAssetTypes();
        ctrl.assets = ctrl.assets || [];
        ctrl.contacts = ctrl.contacts || [];
        ctrl.workflow = ctrl.workflow || {};
        ctrl.countries = ctrl.countries || [];
        ctrl.lenders = ctrl.lenders || [];
        ctrl.ticketOwner = ctrl.ticketOwner || {};
        ctrl.diversificationOpportunities = ctrl.diversificationOpportunities || [];
        ctrl.addresses = ctrl.addresses || [];
        ctrl.documents = ctrl.documents || [];
        ctrl.outboundReferrers = ctrl.outboundReferrers || [];
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.ticket = ctrl.ticket || {};
        ctrl.idAli = ctrl.idAli || '';
        ctrl.idItem = ctrl.ticket ? ctrl.ticket?.id || '' : ctrl.contacts[0]?.id || '';
        ctrl.isContactAsset = ctrl.isContactAsset || false;
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;
        ctrl.setDiversificationOpportunities();
        if (ctrl.assets?.length) {
          ctrl.getAssetsEstimate();
        }
        ctrl.isReady = true;
      };

      ctrl.assetTypeGetName = (assetType) => {
        const name = assetType.title;
        return name.replace(' address', '');
      };

      ctrl.assetAdd = (assetType) => {
        assetsService.assetAdd(ctrl.assets, assetType, ctrl.contacts);
        ctrl.setDiversificationOpportunities();
        ctrl.onValidated();
      };

      ctrl.assetDelete = (asset) => {
        const idx = helperService.findIndexById(ctrl.assets, asset.id);
        if (idx > -1) {
          ctrl.assets = assetsService.assetDelete(ctrl.assets, idx);
          ctrl.saveAssets();
        }
      };

      ctrl.getLastIndex = (data, idType) => helperService.getLastIndex(data, idType);

      ctrl.isAssetTypeInvestment = (asset) =>
        helperService.isAssetTypeInvestment(asset?.assetType);

      ctrl.isAssetTypeVehicle = (asset) => helperService.isAssetTypeVehicle(asset?.assetType);

      ctrl.isAssetTypeInvestmentExisting = () =>
        _.some(ctrl.assets, (a) => helperService.isAssetTypeInvestment(a?.assetType));

      ctrl.isAssetTypeVehicleExisting = () =>
        _.some(ctrl.assets, (a) => helperService.isAssetTypeVehicle(a?.assetType));

      ctrl.isVehicleOverTwoYears = (asset) => {
        if (asset?.vehicleBuildDate) {
          const years = moment.utc().diff(moment.utc(asset?.vehicleBuildDate, 'X'), 'years');
          return years ? years >= 2 : false;
        }
        return false;
      };

      ctrl.isThereAnyVehicleOverTwoTears = () => {
        const vehicles = _.filter(ctrl.assets, (a) =>
          helperService.isAssetTypeVehicle(a?.assetType)
        );
        return _.some(vehicles, (a) => ctrl.isVehicleOverTwoYears(a));
      };

      ctrl.setDiversificationOpportunities = () => {
        if (!_.isEmpty(ctrl.workflow) && ctrl.workflow?.isHomeLoan()) {
          if (ctrl.isAssetTypeInvestmentExisting()) {
            ctrl.propertyInvestmentLandlord =
              OpportunityContextualType.property_investment_landlord;
            ctrl.propertyInvestmentAgents =
              OpportunityContextualType.property_investment_agents;
          } else {
            const idxLandlord =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.property_investment_landlord
                }
              );
            if (idxLandlord > -1) {
              ctrl.diversificationOpportunities.splice(idxLandlord, 1);
            }
            const idxAgents =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.property_investment_agents
                }
              );
            if (idxAgents > -1) {
              ctrl.diversificationOpportunities.splice(idxAgents, 1);
            }
          }

          if (ctrl.isAssetTypeVehicleExisting()) {
            if (ctrl.isThereAnyVehicleOverTwoTears()) {
              ctrl.assetVehicleAdvocacy = OpportunityContextualType.asset_vehicle_advocacy;
              ctrl.assetVehicleFinance = OpportunityContextualType.asset_vehicle_finance;
            } else {
              const idxAdvocacy =
                diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                  {
                    diversificationOpportunities: ctrl.diversificationOpportunities,
                    typeContextual: OpportunityContextualType.asset_vehicle_advocacy
                  }
                );
              if (idxAdvocacy > -1) {
                ctrl.diversificationOpportunities.splice(idxAdvocacy, 1);
              }
              const idxFinance =
                diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                  {
                    diversificationOpportunities: ctrl.diversificationOpportunities,
                    typeContextual: OpportunityContextualType.asset_vehicle_finance
                  }
                );
              if (idxFinance > -1) {
                ctrl.diversificationOpportunities.splice(idxFinance, 1);
              }
            }
            ctrl.assetVehicleWarranty = OpportunityContextualType.asset_vehicle_warranty;
          } else {
            const idxWarranty =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.asset_vehicle_warranty
                }
              );
            if (idxWarranty > -1) {
              ctrl.diversificationOpportunities.splice(idxWarranty, 1);
            }
            const idxAdvocacy =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.asset_vehicle_advocacy
                }
              );
            if (idxAdvocacy > -1) {
              ctrl.diversificationOpportunities.splice(idxAdvocacy, 1);
            }
            const idxFinance =
              diversificationOpportunityService.getIndexOfContextualTypeInDiversificationOpportunities(
                {
                  diversificationOpportunities: ctrl.diversificationOpportunities,
                  typeContextual: OpportunityContextualType.asset_vehicle_finance
                }
              );
            if (idxFinance > -1) {
              ctrl.diversificationOpportunities.splice(idxFinance, 1);
            }
          }
          ctrl.saveDiversificationOpportunities(ctrl.diversificationOpportunities);
        }
      };

      ctrl.totalAssetsByContact = ({ idContact }) => {
        const totalAssets = _.find(
          ctrl.assetsEstimate?.contacts || [],
          (i) => i?.id === idContact
        );
        return totalAssets ? totalAssets?.totalValue || 0 : 0;
      };

      ctrl.getAssetsEstimate = () => {
        ctrl.isProcessing = true;
        financesService
          .getAssets({ id: ctrl.idItem, type: ctrl.ticket?.id ? 'ticket' : 'contact' })
          .then((res) => {
            if (res?.status) {
              ctrl.assetsEstimate = res?.assets || {};
            }
            ctrl.isProcessing = false;
          });
      };

      ctrl.saveAssets = _.debounce((asset) => {
        if (asset) {
          const idx = helperService.findIndexById(ctrl.assets, asset.id);
          if (idx > -1) {
            ctrl.assets.splice(idx, 1);
            ctrl.assets.splice(idx, 0, asset);
          } else {
            ctrl.assets.push(asset);
          }
        }
        ctrl.setDiversificationOpportunities();
        const data = {
          assets: ctrl.assets,
          tCD: 'assets'
        };
        ctrl.onFinished({ data });
      }, 3000);

      ctrl.saveDiversificationOpportunities = (diversificationOpportunities) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationFinished({ diversificationOpportunities });
        }
      };

      ctrl.saveDiversificationIntegration = (integration, result) => {
        if (ctrl.isReady === true) {
          ctrl.onDiversificationIntegrationFinished({ integration, result });
        }
      };

      ctrl.destroyWatch = eventService.onChangedData((params) => {
        if (params?.changedData === 'assets') {
          ctrl.getAssetsEstimate();
        } else {
          ctrl.isProcessing = false;
        }
      });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onDestroy = () => {
        ctrl.destroyWatch();
      };
    }
  }
};
